import { m } from "@/paraglide/messages";

/**
 * Curated letters pages — the ONLY indexable /word-unscrambler/$letters URLs
 * (they are the ones listed in the sitemap). Each carries unique editorial
 * copy about that word's anagram family; every other letters combination is
 * noindexed by the route, because an unbounded catch-all of template pages is
 * the doorway-content pattern AdSense rejected the site for.
 */
export interface CuratedWord {
  howTo: () => string;
  faqs: Array<{ q: () => string; a: () => string }>;
}

export const CURATED_WORDS: Record<string, CuratedWord> = {
  listen: {
    howTo: () => m.wu_c_listen_howto(),
    faqs: [
      { q: () => m.wu_c_listen_faq1_q(), a: () => m.wu_c_listen_faq1_a() },
      { q: () => m.wu_c_listen_faq2_q(), a: () => m.wu_c_listen_faq2_a() },
    ],
  },
  friend: {
    howTo: () => m.wu_c_friend_howto(),
    faqs: [
      { q: () => m.wu_c_friend_faq1_q(), a: () => m.wu_c_friend_faq1_a() },
      { q: () => m.wu_c_friend_faq2_q(), a: () => m.wu_c_friend_faq2_a() },
    ],
  },
  master: {
    howTo: () => m.wu_c_master_howto(),
    faqs: [
      { q: () => m.wu_c_master_faq1_q(), a: () => m.wu_c_master_faq1_a() },
      { q: () => m.wu_c_master_faq2_q(), a: () => m.wu_c_master_faq2_a() },
    ],
  },
  silent: {
    howTo: () => m.wu_c_silent_howto(),
    faqs: [
      { q: () => m.wu_c_silent_faq1_q(), a: () => m.wu_c_silent_faq1_a() },
      { q: () => m.wu_c_silent_faq2_q(), a: () => m.wu_c_silent_faq2_a() },
    ],
  },
  garden: {
    howTo: () => m.wu_c_garden_howto(),
    faqs: [
      { q: () => m.wu_c_garden_faq1_q(), a: () => m.wu_c_garden_faq1_a() },
      { q: () => m.wu_c_garden_faq2_q(), a: () => m.wu_c_garden_faq2_a() },
    ],
  },
};

export function getCurated(letters: string): CuratedWord | undefined {
  return Object.hasOwn(CURATED_WORDS, letters)
    ? CURATED_WORDS[letters]
    : undefined;
}
